import { useMutation, useQueryClient } from '@tanstack/react-query';
import followersService from '~/services/followersService/followers.service';

export const useFollowers = () => {
  const queryClient = useQueryClient();
  const queryKey = ['publicProfile'];

  const followMutation = useMutation({
    mutationFn: (targetUserId: string) => followersService.followUser(targetUserId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const unfollowMutation = useMutation({
    mutationFn: (targetUserId: string) => followersService.unfollowUser(targetUserId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return {
    followUser: followMutation.mutate,
    unfollowUser: unfollowMutation.mutate,
    isFollowLoading: followMutation.isPending,
    isUnfollowLoading: unfollowMutation.isPending,
  };
}; 